import React from 'react'
import createSvgIcon from '../createSvgIcon'

export default createSvgIcon(
  <>
    <defs>
      <linearGradient
        id="errorGradient"
        x1="12"
        y1="0"
        x2="12"
        y2="24"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D9413E" />
        <stop offset="1" stopColor="#AF2F2C" />
      </linearGradient>
    </defs>
    <rect width="24" height="24" rx="6" fill="url(#errorGradient)" />
    <rect
      x="8"
      y="14.84"
      width="9.67"
      height="1.66"
      rx="0.83"
      transform="rotate(-45 8 14.84)"
      fill="white"
    />
    <rect
      x="9.17"
      y="8"
      width="9.67"
      height="1.66"
      rx="0.83"
      transform="rotate(45 9.17 8)"
      fill="white"
    />
  </>,
  'Error',
  24
)
